module.exports = __webpack_public_path__ + "img/nycminus.7c7b98b5.jpg";